import { Route, NavigationGuardNext } from "vue-router";
import { getModule } from "vuex-module-decorators";
import AppSettings from "@/modules/app-settings";
import { Paths } from "@/util/paths";
import { ApplicationViews } from "@/util/enum";

export const ScopeSequenceResolver = async function (to: Route, from: Route, next: NavigationGuardNext) {
	const actions: Promise<void>[] = [];
	const appSetting = getModule(AppSettings) as AppSettings;
	if (to.path == Paths.ScopeSequence) {
		appSetting.setChildMenu(ApplicationViews.ScopeSequence);
	}
	await Promise.all(actions);
	next();
};
